import {configureStore} from '@reduxjs/toolkit';
import versionReducer from './version-slice';
import quickstartReducer, {persistQuickstartState} from './quickstart-slice';

export const store = configureStore({
  reducer: {
    quickstart: quickstartReducer,
    version: versionReducer,
  },
});

// Persist quickstart slice to localStorage on changes
store.subscribe(() => {
  try {
    const state = store.getState()?.quickstart;
    persistQuickstartState(state);
  } catch {
    // ignore persistence errors
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
